module.exports = __webpack_public_path__ + "static/media/collective_member_smiling_2.3c19b849.jpg";